import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import st from "@/styles/Ui.module.scss";
import {useEffect, useRef, useState} from "react";
import EmailIcon1 from "@/svg/EmailIcon1.tsx";
import {useTranslation} from "react-i18next";
import {TextField} from "@mui/material";
import {textfield_sx} from "@/utils/mui_sx.ts";
import auth from "@/hooks/auth.ts";
import DownloadIcon from "@/ui/DownloadIcon.tsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import useLoans from "@/hooks/loans.ts";
import Button from "@/ui/Button.tsx";
import LoginLoader from "@/ui/LoginLoader.tsx";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import {FileXIcon} from "lucide-react";
import {strings} from "@/utils/strings.ts";


interface Props {
    line?:boolean
}

const GetContractModal:React.FC<Props> = ({line/*, contr , credit*/}) => {
    const [credit, set_credit] = useState<LoanInterface | undefined>(undefined)
    // const [contract_atom] = useAtom(contract);
    const {t} = useTranslation()
    const user = auth().current_user()
    const effect_ran = useRef<boolean>(false)
    const loans = useLoans()
    const [contr, set_contr] = useState<any>("")
    // const open = Boolean(typeof credit === "object" && Object.keys(credit).length)
    // const [open, set_open] = useState(false)
    const [loading, set_loading] = useState(true)
    const [email, set_email] = useState<string>("")
    const [no_contract, set_no_contract] = useState(false)
    const [send_error, set_send_error] = useState(false)

    const openModal = (x:LoanInterface) => {
        set_credit(x as LoanInterface)
    }
    
    const send_contract = async () => {
        
        if (!credit) return
        const x_email = user?.email.length ? user?.email : email

        if (!CommonClass.isEmailValid(x_email)) {
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("valid_email_err"))
            set_send_error(true)
            return
        }

        set_loading(true)

        let req:any

        if(line) {
            req = await loans.sendContract({
                id: credit?.id,
                email: x_email
            })
        } else {
            req = await loans.sendContract({
                id: credit?.id,
                email: x_email
            })
        }
        
        set_send_error(!req)
        set_loading(false)
    }
    
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = contr;
        link.download = strings.doc_name.replace("{{urn}}", credit?.urn || "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
    };

    const get_contr = async () => {
        // set_loading(true)

        const res = await loans.getContract({
            id: credit?.id,
            uid: credit?.urn
        }, credit?.urn || "", true);


        if(res !== undefined) {
            set_contr(res)
            
        } else {
            set_no_contract(true)
        }
        
        set_loading(false)
    }


    useEffect(() => {
        if(typeof credit !== "undefined" && contr === "") {
            get_contr()
        }
    }, [credit]);

    useEffect(() => {
        
        if(!effect_ran.current) {
            eventEmitter.on(CommonClass.ModalEvents.OpenGetContractModal, openModal)
        }
        
        return () => {
            effect_ran.current = true
            
            if(!effect_ran.current) {
                set_contr("")
                eventEmitter.off(CommonClass.ModalEvents.OpenGetContractModal, openModal)
            }
        }
    }, []);
    
    
    return (
        <ModalLayout
            className={st.get_contract_modal}
            open={Boolean(credit)}
            innerClassName={st.get_contract_modal_inner}
            on_close_state={() => {
                set_credit(undefined)
                set_no_contract(false)
                set_loading(true)
                set_send_error(false)
                set_contr("")
            }}
        >
            
            {Boolean(credit) && (
                <>
                    {no_contract ? (
                        <div className={st.no_contract}>
                            <FileXIcon />
                            
                            <div>
                                <strong >{t("no_contract")}</strong>
                                
                                <p>{t("no_contract_reason")}</p>
                            </div>
                            
                            <Button
                                outlined
                                onClick={() => set_credit(undefined)}
                            >
                                {t("close")}
                            </Button>
                        </div>
                    ) : (
                        <>
                            
                            {!loading ? (
                                <>
                                    {!line && (
                                        <div className={st.send_to_email}>
                                            <EmailIcon1/>
                                            
                                            <span>
                                                {t("get_contract_by_email")}
                                            </span>
                                            
                                            <TextField
                                                name={"email"}
                                                type={"email"}
                                                label={t("email_address")}
                                                error={send_error}
                                                color={"success"}
                                                sx={textfield_sx}
                                                onChange={(e) => {
                                                    set_email(e.target.value)
                                                }}
                                                disabled={Boolean(user?.email.length)}
                                                defaultValue={user?.email}
                                                onFocus={() => {
                                                    eventEmitter.emit(CommonClass.ModalEvents.FocusInputs, true)
                                                }}
                                                onBlur={() => {
                                                    eventEmitter.emit(CommonClass.ModalEvents.FocusInputs, false)
                                                }}
                                            />
                                            
                                            <Button
                                                onClick={() => {
                                                    send_contract()
                                                }}
                                            >
                                                {t("send")}
                                            </Button>
                                        
                                        </div>
                                    )}
                                    
                                    <div className={st.dwn_icon_cont}>
                                        <DownloadIcon/>
                                        
                                        <span>
                                            {t("download_contract")}
                                        </span>
                                    </div>
                                    
                                    <Button
                                        onClick={handleDownload}
                                    >
                                        {t("download")}
                                    </Button>
                                </>
                            ) : <LoginLoader className={st.loader}/>}

                        </>
                    )}
                    
                </>
            )}
        
        </ModalLayout>
    )
}

export default GetContractModal